import DropZone from '@hobs/components/DropZone';
import { connect } from 'react-redux';
import { H2 } from '@hobs/components/Headings';
import Panel from '@hobs/components/Panel';
import { withRouter } from 'react-router-dom';
import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import {
  Formik,
  Form
} from 'formik';
import ShortId from 'shortid';
import { updateGeneralAttachments } from '@hobs/actions/serviceRequests';
import Toast from '@hobs/components/Toast';
import { ACCEPTED_FILE_FORMATS } from '@hobs/utils/constants';
import { createLoadingSelector } from '@hobs/utils/loading';
import Tooltip from '@hobs/components/Tooltip';
import ConfirmActionDialog from '@hobs/containers/ConfirmActionDialog/ConfirmActionDialog';

const GeneralAttachments = ({ 
  t, 
  disabled,
  attachments,
  onFileSelect,
  updateGeneralAttachments,
  match,
  isLoading
 }) => {
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [attachmentList, setAttachmentList] = useState([]);

  const getInitialValues = () => {
    return {
      attachments: attachments
    }
  }
  const updateAttachments = (values, setSubmitting, setFieldValue, addedAttachments) => {
    setSubmitting(true);
    const attachmentsModel = {
      attachments: Array.from(values.attachments, x => x.attachmentId)
    }
    updateGeneralAttachments(match.params.serviceRequestId, attachmentsModel)
      .then(() => {
        const isAdded = addedAttachments.length
        Toast.success(t(`File ${isAdded ? 'uploaded' : 'removed'} successfully`));
        setFieldValue('attachments', values.attachments);
        
        setSubmitting(false);
      })
  }

  const onRemove = (setSubmitting, setFieldValue) => {
    setConfirmationDialogOpen(false)
    const attachments = {
      attachments: attachmentList
    }
    updateAttachments(attachments, setSubmitting, setFieldValue, [])
  }

  return (
    <Panel>
      <div className="request-information--panel">
        <Tooltip tooltip={t('Files only visible to Host Nation and Sending Nation')} position="top">
          <H2>{t('General attachments')}</H2>
        </Tooltip>
        <Formik
          validateOnBlur={false}
          validateOnChange={false}
          enableReinitialize={true}
          initialValues={getInitialValues()}
          onSubmit={() => {}}
        >
          {({
            setFieldValue,
            setSubmitting,
            values
          }) => {
            return (
              <>
                <Form noValidate={true}>
                  <DropZone 
                    onSelect={files => {
                      onFileSelect(files).then(response => {
                        if (response.success === false) {
                          return;
                        }
                        const attachments = {
                          attachments: values.attachments.concat(response.payload)
                        }
                        updateAttachments(
                          attachments, 
                          setSubmitting, 
                          setFieldValue, 
                          response.payload)
                      });
                    }}
                    onRemove={(file, list) => {
                      setConfirmationDialogOpen(true);
                      setAttachmentList(list);
                    }}
                    value={values.attachments ? values.attachments : []}
                    key={ShortId.generate()}
                    disabled={disabled}
                    accepted={ACCEPTED_FILE_FORMATS}
                    isLoading={isLoading}
                  />
                </Form>
                <ConfirmActionDialog
                  title={t('Confirm file deletion')}
                  text={t('Are you sure you want to delete this file?')}
                  onConfirm={() => onRemove(setSubmitting, setFieldValue)}
                  onCancel={() => setConfirmationDialogOpen(false)}
                  isDialogOpen={confirmationDialogOpen}
                />
              </>
            )
          }}
        </Formik>
      </div>
    </Panel>
  )
}
const isUploadingFiles = createLoadingSelector([
  'ServiceRequests/UpdateGeneralAttachments',
  'Attachments/Upload'
]);
const mapStateToProps = state => {
  return {
    isLoading: isUploadingFiles(state),
  };
};
const mapDispatchToProps = {
  updateGeneralAttachments
}
export default connect(
  mapStateToProps, 
  mapDispatchToProps
)(
  withRouter(withTranslation()(GeneralAttachments))
);